import { render } from "./SummaryBox1.vue?vue&type=template&id=09aead10&scoped=true"
import script from "./SummaryBox1.vue?vue&type=script&lang=js"
export * from "./SummaryBox1.vue?vue&type=script&lang=js"

import "./SummaryBox1.vue?vue&type=style&index=0&id=09aead10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aead10"]])

export default __exports__